<img [attr.width]="width" [attr.height]="height" [attr.src]="src" />
